import actions from './actionTypes';
import { paymentMeanDetailsModalService } from '../services/paymentMeanDetailsServices';
export const callKlarna = (price) => (dispatch) => {
    dispatch({ type: actions.START_LOADING_KLARNA });
    paymentMeanDetailsModalService
        .callKlarna({
        price,
    })
        .then(response => {
        dispatch({
            type: actions.KLARNA,
            payload: response.data,
        });
    })
        .catch(err => {
        dispatch({
            type: actions.HANDLE_ERROR,
        });
        console.log(`error: ${err}`);
    });
};
export const callFloa = (price) => (dispatch) => {
    dispatch({ type: actions.START_LOADING_FLOA });
    paymentMeanDetailsModalService
        .callFloa({
        price,
    })
        .then(response => {
        dispatch({
            type: actions.FLOA,
            payload: response.data,
        });
    })
        .catch(err => {
        dispatch({
            type: actions.FLOA,
            payload: { name: 'FLOA', monthlyPayment: 10 },
        });
        console.log(`error: ${err}`);
    });
};
